import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes.jsx';
import SchoolMap from './components/SchoolMap/Index.jsx';
import SchoolMapSingle from './components/SchoolMapSingle/Index.jsx';
import SchoolsEnglish from './components/SchoolsEnglish/Index.jsx';
import CoursesEnglish from './components/CoursesEnglish/Index.jsx';
import AccomodationMap from './components/AccomodationMap/Index.jsx';
import AccomodationsMap from './components/AccomodationsMap.jsx';
import loadGoogleMapsAPI from 'load-google-maps-api';
import SchoolCourseList from './components/SchoolCourseList.jsx';
import CourseList from './components/CourseList.jsx';
import GlobalSearch from './components/GlobalSearch/Index.jsx';

const frontpage = document.getElementById('react-app');
const schoolMap = document.getElementById('react-school-map');
const schoolsEnglish = document.getElementById('react-schools');
const coursesEnglish = document.getElementById('react-courses');
const courseList = document.getElementById('react-courselist');
const schoolCourseList = document.getElementById('react-school-courselist');
const globalSearch = document.getElementById('react-search');

if (frontpage) {
    ReactDOM.render(
        <Routes />,
        frontpage
    );
}

if (schoolMap) {
    window.addEventListener('load', function() {
        ReactDOM.render(
            <SchoolMap />,
            schoolMap
        );
    });
}

if (schoolsEnglish) {
    window.addEventListener('load', function() {
        ReactDOM.render(
            <SchoolsEnglish schools={schools} />,
            schoolsEnglish
        );
    });
}

if (coursesEnglish) {
    window.addEventListener('load', function() {
        ReactDOM.render(
            <CoursesEnglish courses={window.courses} schools={window.schools} restplassCount="0" />,
            coursesEnglish
        );
    });
}

if (courseList) {
    const courseLimit = parseInt(courseList.dataset.limit) || 28;

    ReactDOM.render(
        <CourseList courses={window.courses} schools={window.schools} lang={window.lang} limit={courseLimit} />,
        courseList
    );
}

if (schoolCourseList) {
    ReactDOM.render(
        <SchoolCourseList courses={window.courses} schools={window.schools} lang={window.lang} limit={100} />,
        schoolCourseList
    );
}

if (globalSearch) {
    const pageLang = document.querySelector('html').lang;
    ReactDOM.render(
        <GlobalSearch id={globalSearch.dataset.id} token={globalSearch.dataset.token} lang={pageLang} pageLimit={globalSearch.dataset.pagelimit} />,
        globalSearch
    );
}

// Render single map in accordion on click (deferred to reduce maps billing cost)
const mapTriggers = document.querySelectorAll('[data-accordion]');
const arr = [].slice.call(mapTriggers);

arr.forEach((trigger) => {
    trigger.addEventListener('click', () => {
        if (trigger.hasAttribute('data-map-loaded')) {
            return;
        }

        const schoolMapSingle = document.getElementById('react-school-map-single');
        if (schoolMapSingle) {
            ReactDOM.render(
                <SchoolMapSingle {...(schoolMapSingle.dataset)} />,
                schoolMapSingle
            );
        }

        trigger.setAttribute('data-map-loaded', '1');
    });
});

let accomodationMaps = document.querySelectorAll('.accomodation__map');
accomodationMaps = [].slice.call(accomodationMaps)

const accomodationOverview = document.querySelector('.accomodation__overview');

if (accomodationMaps.length || accomodationOverview) {
    loadGoogleMapsAPI({
        key: 'AIzaSyARHfNm86RrNT4tbsrzXGgT7gylkeSl6-M',
        libraries: 'geometry'
    }).then(() => {
        accomodationMaps.forEach((map) => {
            ReactDOM.render(
                <AccomodationMap {...(map.dataset)} />,
                map
            );
        });

        if (accomodationOverview) {
            ReactDOM.render(
                <AccomodationsMap schools={window.accomodationMapJson} />,
                accomodationOverview
            );
        }
    });
}


